const data = {
  prevPage: "Prev Page",
  nextPage: "Next Page",
  page: "Page",
  submit: "Submit",
  loading: "loading...",
  tips: "Tips",
  confirm: "Confirm",
  cancel: "Cancel",
  "upload.failed": "Upload Failed",
  "upload.text": "Select Image",
  "questionTitle.type.checkbox": "Multiple choice",
  "questionTitle.type.sort": "Sort",
  "questionTitle.noRequired": "Optional",
  "questionTitle.clearTxt": "清除选择",
  "questionTitle.choiceTxt-between": "请选择$1-$2项",
  "questionTitle.choiceTxt-less": "至少选择$1项",
  "questionTitle.choiceTxt-more": "至多选择$1项",
  againTxt: "您之前已经回答了部分题目，是否继续上次回答",
  "preview.submitTips": "此问卷为预览状态，不能提交",
  "tipsPage.success": "提交成功",
  "tipsPage.network": "网络不给力",
  "tipsPage.10003": "问卷暂未发布,不能填写问卷",
  "tipsPage.10004": "你已回答过该问卷",
  "tipsPage.10005": "该问卷已结束调研",
  "tipsPage.10006": "找不到该问卷",
  "tipsPage.10007": "该问卷已删除",
  "tipsPage.tips.subtxt": "我们的每一次进步都离不开你的支持",
  "tipsPage.refreshBtn": "Refresh",
  "errormsg.pleaseAnswer": "请回答此题",
  "errormsg.textRequire": "文本框内容必须填写",
  "errormsg.upload.ing": "文本框内容必须填写",
  "errormsg.upload.failed": "文件上传失败，请重新上传"
};

export default data;
